import api from './api'
import http from './http'
import bxlutils from 'bxl-utils'
export const searchProducts = (data, hiddenTerm) => {
  let postData = {
    q: bxlutils.uri.stringify({
      ...data
    }),
    hiddenTerm: hiddenTerm
  }
  if (!hiddenTerm) delete postData.hiddenTerm
  return http.post(
    api.searchProducts,
    postData,
    {
      headers: {
        'Content-Type': 'application/x-protobuf-json'
      }
    }
  )
}

export const getCartProductNum = () => {
  return http.get(api.getShoppingCartInfo)
}

export const getBrands = (n) => {
  return http.get(api.getBrands(n))
}

export const getCategorys = () => {
  return http.get(api.getCategorys)
}

export const getMerchants = () => {
  return http.get(api.getMerchants)
}

export const loadPromoDetail=(promoId)=>{
  return http.get(api.get_promo_by_id + '/' + promoId)
}

export const getHotWords = () =>{
  return http.get(api.get_hot_words)
}